import React from 'react'
import './teacher-portal-2021.css'
import { baseUrl } from '../assets/Animations'
import { PasswordWarning } from '../PasswordWarning'
import Axios from 'axios'
import AvailabilityByDayPopup from './AvailabilityByDayPopup/AvailabilityByDayPopup'
import ThankYouForSubmitting from '../CreateTimesheet/ThankYouForSubmitting/ThankYouForSubmitting'
import CreateTimesheet from '../CreateTimesheet/CreateTimesheet'
import OldTimesheet from '../CreateTimesheet/OldTimesheet/OldTimesheet'
import MoreStudentsPopup from './MoreStudentsPopup/MoreStudentsPopup'

import {Helmet} from 'react-helmet'
import TeacherPortalCalendar from '../TeacherPortalCalendar/TeacherPortalCalendar'
import AutoPopulatedTimesheet from './AutoPopulatedTimesheet/AutoPopulatedTimesheet'
import { format, parse } from 'date-fns'
import { socket, disconnectSocket } from '../service/socket'
import TeacherPortalBottomMenu from './TeacherPortalBottomMenu/TeacherPortalBottomMenu'
import NotesPopupTeacherPortal from './NotesPopupTeacherPortal/NotesPopupTeacherPortal'
import { ButtonWithLeadingIconXLarge } from '../DanitComponents/Buttons/ButtonWithLeadingIcon'
import { HorizontalLinkCard } from '../DanitComponents/Task Cards/HorizontalLinkCard'
import { PrimaryButtonMedium } from '../DanitComponents/Buttons/PrimaryButton'
import { InputWithInsetLabel } from '../DanitComponents/Inputs/InputWithInsetLabel'

let typingTimer;

const TeacherPortal2021 = (props) => {
    const [view, setView] = React.useState('')
    const [oldTimesheets, setOldTimesheets] = React.useState([])
    const [firstPass, setFirstPass] = React.useState('')
    const [secondPass, setSecondPass] = React.useState('')
    const [email, setEmail] = React.useState('')
    const [needsToReset, setNeedsToReset] = React.useState(Boolean)
    const [passWarning, setPassWarning] = React.useState(false)
    const [availabilityByDay, setAvailabilityByDay] = React.useState('')
    const [teacherAvail, setTeacherAvail] = React.useState({})
    const [teacherNotes, setTeacherNotes] = React.useState('')
    const [month, setMonth] = React.useState('')
    const [year, setYear] = React.useState('')
    const [startDate, setStartDate] = React.useState('')
    const [endDate, setEndDate] = React.useState('')
    const [schoolLogo, setSchoolLogo] = React.useState('')
    const [schoolAbb, setSchoolAbb] = React.useState('')
    const [otherSchoolAbb, setOtherSchoolAbb] = React.useState('')
    const [schoolName, setSchoolName] = React.useState('')
    const [openUpTheTimesheet, setOpenUpTheTimesheet] = React.useState(false)
    const [thankYouForSubmitting, setThankYouForSubmitting] = React.useState(false)
    const [oldTimesheet, setOldTimesheet] = React.useState(false)
    const [phone, setPhone] = React.useState('')
    const [address, setAddress] = React.useState({})
    const [loadingId, setLoadingId] = React.useState('')
    const [wantsMoreStudents, setWantsMoreStudents] = React.useState(true)
    const [openAvailabilityPopup, setOpenAvailabilityPopup] = React.useState(false)
    const [wantsMoreStudentsPopup, setWantsMoreStudentsPopup] = React.useState(false)
    const [tryingToSubmitTimesheet, setTryingToSubmitTimesheet] = React.useState(false)
    const [backgroundImage, setBackgroundImage] = React.useState('')
    const [logo, setLogo] = React.useState('')
    const [bottomMenuView, setBottomMenuView] = React.useState('timesheets')
    const [notesPopup, setNotesPopup] = React.useState(false)

    const initialRender1 = React.useRef(true)
    const initialRender2 = React.useRef(true)
    const initialRender3 = React.useRef(true)

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    const allDays = [{ day: 'Monday', abbr: 'Mon'},{ day: 'Tuesday', abbr: 'Tue'},{ day: 'Wednesday', abbr: 'Wed'},{ day: 'Thursday', abbr: 'Thu'},{ day: 'Friday', abbr: 'Fri'},{ day: 'Saturday', abbr: 'Sat'},{ day: 'Sunday', abbr: 'Sun'}]

    React.useEffect(() => {
        createDateSettings()

        const handleSocketConnection = () => {
            if (document.visibilityState === 'visible') {
                if(socket.connected === false) {
                    socket.connect()
                }
            } else {
                disconnectSocket()
            }
          }

        window.addEventListener('visibilitychange', handleSocketConnection)

        return () => {
            window.removeEventListener('visibilitychange', handleSocketConnection)
        }
    },[])

    React.useEffect(() => {
        setView(bottomMenuView)
    }, [bottomMenuView])


    //INITIALIZING STATE BASED ON USERDATA ONCE WE GET IT
    React.useEffect(() => {
        if(JSON.stringify(props.userData) !== JSON.stringify({})) {
            setPhone(props.userData.PhoneNumber)
            setAddress({
                StreetAddress: props.userData.Address.StreetAddress,
                City: props.userData.Address.City,
                State: props.userData.Address.State,
                Zip: props.userData.Address.Zip
            })
            setWantsMoreStudents(props.userData.WantsMoreStudents)
            setTeacherAvail(props.userData.AvailabilityDetails)
            setTeacherNotes(props.userData.Notes)
            setBackgroundImage(props.userData.School.toUpperCase())
            setNeedsToReset(props.userData.NeedsToReset)
            setEmail(props.userData.Email)
            setTheSchool()
            if(props.userData.School === 'mma'){
                setLogo('mmalogo.png')
            }
            else if(props.userData.School === 'lsma'){
                setLogo('lakesidelogo.png')
            }
            else if(props.userData.School === 'tma'){
                setLogo('treesidelogo.png')
            }
            else if(props.userData.School === 'mor'){
                setLogo('morningsidelogo.png')
            }
            else if(props.userData.School === 'psma'){
                setLogo('parksidelogo.png')
            }
            initialRender1.current = true
            initialRender2.current = true
            initialRender3.current = true
        }
    }, [props.userData])




    React.useEffect(() => {
        if(view === 'timesheets') {
            getOldTimesheets()
        }
    }, [view])

    React.useEffect(() => {
        if(initialRender1.current && JSON.stringify(address) === JSON.stringify({})) {
            return
        } else if (initialRender1.current) {
            initialRender1.current = false
        } else {
            typingTimer = setTimeout(() => sendTheUpdate(loadingId), 500)
        }
    }, [address])

    React.useEffect(() => {
        if(initialRender2.current && phone === '') {
            return
        } else if (initialRender2.current) {
            initialRender2.current = false
        } else {
            typingTimer = setTimeout(() => sendTheUpdate(loadingId), 500)
        }
    }, [phone])

    // React.useEffect(() => {
    //     if(initialRender3.current && teacherNotes === '') {
    //         return
    //     } else if (initialRender3.current) {
    //         initialRender3.current = false
    //     } else {
    //         typingTimer = setTimeout(() => sendTheNotes(loadingId), 200)
    //     }
    // }, [teacherNotes])

    const setTheSchool = () => {
        let url = window.location.href
        let trimmed = url.substring(8)
        let name = trimmed.split('.')[0]
        if(name === 'mountainside' || name === 'ocalhost:3000/teacherportal' || name === 'ocalhost:8080/teacherportal/') {
            setSchoolAbb('MMA')
            setSchoolLogo('mmalogo.png')
            setSchoolName('Mountainside Music Academy')
            setOtherSchoolAbb('mma')
        } else if (name === 'lakeside') {
            setSchoolAbb('LSMA')
            setSchoolLogo("lakesidelogo.png")
            setSchoolName('Lakeside Music Academy')
            setOtherSchoolAbb('lsma')
        } else if (name === 'treeside') {
            setSchoolAbb('TMA')
            setSchoolLogo('treesidelogo.png')
            setSchoolName('Treeside Music Academy')
            setOtherSchoolAbb('tsma')
        } else if (name === 'greatlakes') {
            setSchoolAbb('MOR')
            setSchoolLogo('morningsidelogo.png')
            setSchoolName('Morningside Music Academy')
            setOtherSchoolAbb('mor')
        }
    }



    const createDateSettings = () => {
        let d = new Date()
        let month = d.getMonth()
        let day = d.getDate()
        let theYear = d.getFullYear()
        let adjustedMonth;
        if(day < 15) {
            if(month !== 0) {
                adjustedMonth = month - 1
            } else {
                adjustedMonth = 12
            }
        } else {
            adjustedMonth = month
        }
        if (adjustedMonth === 0) {
            setMonth('January')
            setStartDate(`${theYear}-01-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-02-01T00:00:00.00-07:00`)
            setYear(theYear)
        } else if (adjustedMonth === 1) {
            setMonth('February')
            setStartDate(`${theYear}-02-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-03-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 2) {
            setMonth('March')
            setStartDate(`${theYear}-03-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-04-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 3) {
            setMonth('April')
            setStartDate(`${theYear}-04-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-05-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 4) {
            setMonth('May')
            setStartDate(`${theYear}-05-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-06-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 5) {
            setMonth('June')
            setStartDate(`${theYear}-06-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-07-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 6) {
            setMonth('July')
            setStartDate(`${theYear}-07-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-08-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 7) {
            setMonth('August')
            setStartDate(`${theYear}-08-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-09-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 8) {
            setMonth('September')
            setStartDate(`${theYear}-09-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-10-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 9) {
            setMonth('October')
            setStartDate(`${theYear}-10-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-11-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 10) {
            setMonth('November')
            setStartDate(`${theYear}-11-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-12-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 11) {
            setMonth('December')
            setStartDate(`${theYear}-12-01T00:00:00.00-07:00`)
            setEndDate(`${theYear + 1}-01-01T00:00:00.00-07:00`)
            setYear(theYear)
        }else if (adjustedMonth === 12) {
            setMonth('December')
            setStartDate(`${theYear - 1}-12-01T00:00:00.00-07:00`)
            setEndDate(`${theYear}-01-01T00:00:00.00-07:00`)
            let adjustedYear = theYear - 1
            setYear(adjustedYear)
        }
    }

    const getOldTimesheets = async () => {
        let res = await Axios.get(`${baseUrl}/oldtimesheets/${props.userData.TeacherID}`, myHeader)
        setOldTimesheets(res.data)
    }
    const viewOldTimesheet = async (oldTimesheetId) => {
        let res = await Axios.get(`${baseUrl}/oldtimesheet/${oldTimesheetId}`, myHeader)
        setOldTimesheet(res.data)
    }

    const updateAndCloseAvailabilityModal = (wholeAvail) => {
        Axios.put(`${baseUrl}/teacherschedule`, {
            Email: props.userData.Email,
            AvailabilityDetails: wholeAvail
        }, myHeader)
        .then((res) => {
            setTeacherAvail(res.data.AvailabilityDetails)
            setAvailabilityByDay('')
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const updateProfile = (value, hookFunction, id, key) => {
        setLoadingId(id)
        clearTimeout(typingTimer)
        //document.getElementById(id).style.outline = "2px solid orange"
        //document.getElementById(id).style.animation = "loadingBlink 1s linear infinite"
        if(key) {
            hookFunction(oldAddress => ({...oldAddress, [key]: value}))
        } else {
            hookFunction(value)
        }
    }

    const sendWantsMoreStudentsSwitch = (bool) => {
        document.body.style.cursor = 'wait'
        Axios.put(`${baseUrl}/teacherwantsmorestudents/${props.userData.TeacherID}`, {
            Name: props.userData.Name,
            School: props.userData.School,
            WantsMoreStudents: bool
        }, myHeader)
        .then((res) => {
            document.body.style.cursor = 'default'
            setWantsMoreStudents(bool)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const sendTheNotes = (id) => {
        document.body.style.cursor = 'wait'  
        Axios.put(`${baseUrl}/teachernotesupdate`, {
            Email: props.userData.Email,
            Name: props.userData.Name,
            School: props.userData.School,
            Notes: teacherNotes 
        }, myHeader)
        .then((res) => {
            setNotesPopup(false)
            document.body.style.cursor = 'pointer'  
            if(document.getElementById(id)) document.getElementById(id).style.outline = "2px solid green"
            if(document.getElementById(id)) document.getElementById(id).style.animation = "none"
        })
        .catch((err) => {
            document.body.style.cursor = 'pointer'  
            console.log(err)
        })
    }

    const sendTheUpdate = (id) => {
        Axios.put(`${baseUrl}/teachercontact`, {
            Email: props.userData.Email,
            PhoneNumber: phone,
            Address: address
        }, myHeader)
        .then((res) => {
            if(document.getElementById(id)) document.getElementById(id).style.outline = "2px solid green"
            if(document.getElementById(id)) document.getElementById(id).style.animation = "none"
        })
        .catch((err) => {
            console.log(err)
        })
    }
    const startTimesheetProcess = () => {
        setTryingToSubmitTimesheet(true)
        setWantsMoreStudentsPopup(true)
    }
    const continueTimesheetProcess = () => {
        setView('timesheets')
        setOpenUpTheTimesheet(true)
    }
    const cancelTimesheetProcess = () => {
        setView('')
        setTryingToSubmitTimesheet(false)
    }
    const openUpAvailPopup = (theDay) => {
        if(wantsMoreStudents) {
            setAvailabilityByDay(theDay)
        }
    }
    const pushNewTimesheetToTimesheets = (newSheet) => {
        setOldTimesheets((arr) => [...arr, newSheet])
    }


    const passwordSubmit = () => {
        if(firstPass === secondPass) {
            Axios.put('https://app.atharo.app/passreset', {
                Email: email,
                Password: firstPass,
            })
            .then(response => {
                setNeedsToReset(false)
            })
            .catch(e => {
                console.log('Error Password Update did not work: ' + e)
            })
        }
    }
    const resetPass2 = (e) => {
        setSecondPass(e)
        if(firstPass !== e) {
            setPassWarning(true)
        } else {
            setPassWarning(false)
        }
    }



    if(needsToReset) {
        return(
        <>
            <Helmet>
                <title>{`${schoolName}`}</title>
            </Helmet>
            <div className="login-page pass-reset-page">
            <div className="login-header">
                {schoolAbb} Teacher Portal
            </div>
            <div className="login-box">
                <div className="login-box-title">Password Reset</div>
                <input className="password-input login-input" type="password" placeholder="New password" onChange={e => setFirstPass(e.target.value)} ></input>
                <input className="password-input login-input" type="password" placeholder="Confirm password" onChange={e => resetPass2(e.target.value)} ></input>
                <PasswordWarning passWarning={passWarning} />
                <div className="login-btn reset-pass-btn" onClick={() => passwordSubmit()}>Reset Password</div>
                <div className="password-reset-explaination">Since this is your first time logging in, please enter a personalized password you can remember. Thank you!</div>
            </div>
        </div>
        </>
        )
    }else {
        return (
            <div className="new-teacher-portal">
                {availabilityByDay && <AvailabilityByDayPopup setAvailabilityByDay={setAvailabilityByDay} dayToEdit={availabilityByDay} availability={teacherAvail} updateAndCloseAvailabilityModal={updateAndCloseAvailabilityModal} />}
                {thankYouForSubmitting && <ThankYouForSubmitting setThankYouForSubmitting={setThankYouForSubmitting} />}
                {oldTimesheet && <OldTimesheet oldTimesheet={oldTimesheet} teacher={props.userData} setOldTimesheet={setOldTimesheet} />}
                {openUpTheTimesheet && props.userData.School !== 'psma' && <CreateTimesheet month={month} myYear={year} reviewing={false} rate={props.userData.Rate} userData={props.userData} setOpenUpTheTimesheet={setOpenUpTheTimesheet} setThankYouForSubmitting={setThankYouForSubmitting} setTryingToSubmitTimesheet={setTryingToSubmitTimesheet} pushNewTimesheetToTimesheets={pushNewTimesheetToTimesheets} />}
                {openUpTheTimesheet && props.userData.School === 'psma' && <AutoPopulatedTimesheet month={month} myYear={year} reviewing={false} rate={props.userData.Rate} userData={props.userData} setOpenUpTheTimesheet={setOpenUpTheTimesheet} setThankYouForSubmitting={setThankYouForSubmitting} setTryingToSubmitTimesheet={setTryingToSubmitTimesheet} pushNewTimesheetToTimesheets={pushNewTimesheetToTimesheets}  />}
                {notesPopup && <NotesPopupTeacherPortal setNotesPopup={setNotesPopup} teacherNotes={teacherNotes} setTeacherNotes={setTeacherNotes} sendTheNotes={sendTheNotes} />}
                { view === '' &&
                    <div>
                        <div className="new-teacher-portal__menu-header">
                            <img src={`./${logo}`} className="new-teacher-portal__logo" />
                        </div>
                        <img src={`./${backgroundImage}.jpg`} className="new-teacher-portal__header-background-color" />
                        <div className="new-teacher-portal__header">
                            <img className="new-teacher-portal__teacher-image" src={`https://app.atharo.app/images/${props.userData.ImageName}`} />
                        </div>
                        <div className="new-teacher-portal__header__name">{props.userData.Name}</div>
                        <div className="new-teacher-portal__header__subtext">Music Teacher</div>
                        <div className="new-teacher-portal__dashboard-wrapper">
                            <div className="new-teacher-portal__button" onClick={() => setView('timesheets')}>
                                <div className="new-teacher-portal__icon-wrapper button-icon__timesheet"><img className="new-teacher-portal__button__icon" src="dollar-white.svg"/></div>
                                <div className="new-teacher-portal__button__text">Timesheets</div>
                                <img className="new-teacher-portal__button__arrow" src="./arrow-white.svg" />
                            </div>
                            {(props.userData.School === 'mor' || props.userData.School === 'psma') && <div className="new-teacher-portal__button" onClick={() => setView('calendar')}>
                                <div className="new-teacher-portal__icon-wrapper button-icon__cal"><img className="new-teacher-portal__button__icon" src="./calendar-white.svg"/></div>
                                <div className="new-teacher-portal__button__text">Calendar</div>
                                <img className="new-teacher-portal__button__arrow" src="./arrow-white.svg" />
                            </div>}
                            <div className="new-teacher-portal__button" onClick={() => setView('availability')}>
                                <div className="new-teacher-portal__icon-wrapper button-icon__avail"><img className="new-teacher-portal__button__icon" src="./alarm-white.svg"/></div>
                                <div className="new-teacher-portal__button__text">Availability</div>
                                <img className="new-teacher-portal__button__arrow" src="./arrow-white.svg" />
                            </div>
                            <div className="new-teacher-portal__button" onClick={() => setView('profile')}>
                                <div className="new-teacher-portal__icon-wrapper button-icon__prof"><img className="new-teacher-portal__button__icon" src="./user-white.svg"/></div>
                                <div className="new-teacher-portal__button__text">Profile</div>
                                <img className="new-teacher-portal__button__arrow" src="./arrow-white.svg" />
                            </div>
                        </div>
                        <div className="new-teacher-portal__section-label">My Account</div>
                        <div className="new-teacher-portal__log-out__button" onClick={() => props.logout()}>Log Out</div>
                    </div>
                }
                {view === 'timesheets' && 
                    <div className="new-teacher-portal__timesheets">
                        {wantsMoreStudentsPopup && 
                            <MoreStudentsPopup 
                                wantsMoreStudents={wantsMoreStudents} 
                                sendWantsMoreStudentsSwitch={sendWantsMoreStudentsSwitch} 
                                setOpenUpTheTimesheet={setOpenUpTheTimesheet} 
                                setView={setView}
                                setWantsMoreStudentsPopup={setWantsMoreStudentsPopup}
                                setTryingToSubmitTimesheet={setTryingToSubmitTimesheet}
                            />
                        }
                        {/* <div className="new-teacher-portal__back-arrow-wrapper">
                            <img className="new-teacher-portal__back-arrow" onClick={() => setView('')} src="./arrow.svg" />
                            <div className="new-teacher-portal__header-title">Timesheets</div>
                        </div> */}
                        <div className='new-teacher-portal__page-label__timesheet'>Timesheets</div>
                        <div className='mt-4 w-[80%] mx-auto'>
                            <ButtonWithLeadingIconXLarge text={`Generate ${month} Timesheet`} color={'bg-yellow-500'} action={() => startTimesheetProcess()} />
                        </div>
                        {/* <div className="new-teacher-portal__new-timesheet-button" onClick={() => startTimesheetProcess()}>
                            <img className="new-teacher-portal__new-timesheet-button__dollar-sign" src="./dollar-white.svg" />
                            <div className="new-teacher-portal__new-timesheet-button__dollar-sign__text">+ New Timesheet</div>
                            <img className="new-teacher-portal__new-timesheet-button__arrow" src="./arrow-white.svg" />
                        </div> */}
                        <div className="new-teacher-portal__old-timesheet-wrapper">
                            {oldTimesheets.map((timesheet) => 
                            <div className='my-3'>
                                <HorizontalLinkCard action={() => viewOldTimesheet(timesheet.timesheetId)} name={timesheet.monthYear} badge={{text: timesheet.status.toUpperCase(), color: timesheet.status === 'Approved' ? {background: 'bg-green-200', text: 'text-green-800'} :{background: 'bg-orange-100', text: 'text-orange-800'} }} />
                            </div>
                                // <div key={timesheet.timesheetId} onClick={() => viewOldTimesheet(timesheet.timesheetId)} className="new-teacher-portal__old-timesheet__button">
                                //     {timesheet.monthYear}
                                //     <img className="new-teacher-portal__old-timesheet__arrow" src="./arrow-blue.svg" />
                                // </div>
                            )}
                        </div>
                    </div>
                }
                {view === 'availability' && 
                    <div className="new-teacher-portal__availability">
                        {/* <div className="new-teacher-portal__back-arrow-wrapper">
                        {!tryingToSubmitTimesheet && <img className="new-teacher-portal__back-arrow" onClick={() => setView('')} src="./arrow.svg" />}
                            <div className="new-teacher-portal__header-title" style={tryingToSubmitTimesheet ? {marginTop: "50px"} : {marginTop: "-25px"}}>Availability</div>
                        </div> */}
                        {!tryingToSubmitTimesheet && 
                            <div className="new-teacher-portal__wants-more-students-wrapper">
                                {!wantsMoreStudents && <svg style={{cursor: 'pointer'}} className="new-teacher-portal__switch-svg" viewBox="0 0 511.999 511.999" onClick={() => sendWantsMoreStudentsSwitch(true)}>
                                    <g>
                                    	<g>
                                    		<path fill="rgb(255, 100, 100)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                    			S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                    			c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                                    	</g>
                                    </g>
                                </svg>}
                                {wantsMoreStudents && <svg style={{cursor: 'pointer'}} className="new-teacher-portal__switch-svg" viewBox="0 0 512 512" onClick={() => sendWantsMoreStudentsSwitch(false)}>
                                    <g>
                                    	<g>
                                    		<path fill="rgba(0, 128, 0, 0.8)" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                    			S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                    			c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                                    	</g>
                                    </g>
                                </svg>}
                                {wantsMoreStudents ? <h5 className="new-teacher-portal__switch-description">More students please</h5> : <h5 className="new-teacher-portal__switch-description">I'm Full</h5>}
                            </div>
                        }
                        <div className='new-teacher-portal__page-label'>Availability</div>
                        <div className="new-teacher-portal__all-buttons-wrapper" {...!wantsMoreStudents && {style: {opacity: '0.2'}}}>
                            {allDays.map((day, index) => 
                                <div key={index} className="new-teacher-portal__day-button" {...!wantsMoreStudents && {style: {cursor: 'default'}}} onClick={() => openUpAvailPopup(day.day)}>
                                    <div className='new-teacher-portal__day-button__decoration-strip' style={teacherAvail[day.day].length === 0 ? {backgroundColor: '#E89191'} : {backgroundColor: 'rgb(154, 207, 157)'}}></div>
                                    <div className="new-teacher-portal__day-square">{day.abbr.toUpperCase()}</div>
                                    <div className="new-teacher-portal__label-area">
                                        {teacherAvail[day.day].map((timeInterval, i) => 
                                            <div key={i} className="new-teacher-portal__day-button__availability">{format(parse(timeInterval.start, 'H:mm', new Date()), 'h:mm a')} - {format(parse(timeInterval.end, 'H:mm', new Date()), 'h:mm a')}</div>
                                        )}
                                        {teacherAvail[day.day].length === 0 && <div className="new-teacher-portal__day-button__availability not__available">Not Available</div>}
                                    </div>
                                    {/* <img className="new-teacher-portal__day-button__arrow" src="./arrow-dark-blue.svg"/> */}
                                </div>
                            )}
                        </div>
                        <div className="new-teacher-portal__teacher-notes__wrapper">
                            {/* <textarea id="new-teacher-portal__teacher-notes" className="new-teacher-portal__teacher-notes" placeholder="Notes..." value={teacherNotes} onChange={(e) => updateProfile(e.target.value, setTeacherNotes, 'new-teacher-portal__teacher-notes', false)} /> */}
                            <div className='new-teacher-portal__new-teacher-notes'>{teacherNotes}</div>
                            {/* <InputWithInsetLabel label={'Notes:'} placeholder={'Your notes to us...'} value={teacherNotes} /> */}
                            <PrimaryButtonMedium action={() => setNotesPopup(true)} text={'Edit Note'} color={{background: 'bg-blue-500', text: 'text-white', backgroundHover: 'bg-blue-400'}} />
                            {/* <div className='new-teacher-portal__edit-note-btn' onClick={() => setNotesPopup(true)}>Edit Note</div> */}
                        </div>
                        {tryingToSubmitTimesheet && <div className="new-teacher-portal__next-btn" onClick={() => continueTimesheetProcess()}>Continue</div>}
                        {tryingToSubmitTimesheet && <div className="new-teacher-portal__cancel-btn" onClick={() => cancelTimesheetProcess()}>cancel</div>}
                    </div>
                }
                {view === 'profile' && 
                    <div className="new-teacher-portal__profile">
                        <div className="new-teacher-portal__back-arrow-wrapper">
                            {/* <img className="new-teacher-portal__back-arrow" onClick={() => setView('')} src="./arrow-white.svg" />
                            <div className="new-teacher-portal__header-title" style={{color: "#fff"}}>Profile</div> */}
                            <div className="new-teacher-portal__header">
                                <img className="new-teacher-portal__teacher-image" src={`https://app.atharo.app/images/${props.userData.ImageName}`} />
                            </div>
                            <div className="new-teacher-portal__header__name">{props.userData.Name}</div>
                            <div className="new-teacher-portal__header__subtext">Music Teacher</div>
                            <label className="new-teacher-portal__profile-input__label">Phone Number</label>
                            <input className="new-teacher-portal__profile-input" id="new-teacher-portal__phone" value={phone} onBlur={(e) => document.getElementById(e.target.id).style.outline = "none"} onChange={(e) => updateProfile(e.target.value, setPhone, "new-teacher-portal__phone", false)} />
                            <label className="new-teacher-portal__profile-input__label">Street Address</label>
                            <input className="new-teacher-portal__profile-input" id="new-teacher-portal__street" value={address.StreetAddress} onBlur={(e) => document.getElementById(e.target.id).style.outline = "none"} onChange={(e) => updateProfile(e.target.value, setAddress, "new-teacher-portal__street", 'StreetAddress')} />
                            <label className="new-teacher-portal__profile-input__label">City</label>
                            <input className="new-teacher-portal__profile-input" id="new-teacher-portal__city" value={address.City} onBlur={(e) => document.getElementById(e.target.id).style.outline = "none"} onChange={(e) => updateProfile(e.target.value, setAddress, "new-teacher-portal__city", 'City')} />
                            <label className="new-teacher-portal__profile-input__label">State</label>
                            <input className="new-teacher-portal__profile-input" id="new-teacher-portal__state" value={address.State} onBlur={(e) => document.getElementById(e.target.id).style.outline = "none"} onChange={(e) => updateProfile(e.target.value, setAddress, "new-teacher-portal__state", 'State')} />
                            <label className="new-teacher-portal__profile-input__label">Zip Code</label>
                            <input className="new-teacher-portal__profile-input" id="new-teacher-portal__zip" value={address.Zip} onBlur={(e) => document.getElementById(e.target.id).style.outline = "none"} onChange={(e) => updateProfile(e.target.value, setAddress, "new-teacher-portal__zip", 'Zip')} />
                        </div>
                    </div>
                }
                {view === 'calendar' && <TeacherPortalCalendar setView={setView} userData={props.userData} socket={socket} />}
                <TeacherPortalBottomMenu bottomMenuView={bottomMenuView} setBottomMenuView={setBottomMenuView} userData={props.userData} />
            </div>
        )
    }
}
export default TeacherPortal2021